import React, { useEffect, useRef } from "react";
import { IKImage } from "imagekitio-react";
import { useState } from "react";
import { nextSubscription, getDayDecor } from "../../../utils/subscription";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getLeads } from "../../../redux/actions/userSubscription";
import { createLeadScore } from "../../../redux/actions/pricing";
import Constants, {
  leadScoringActivity,
  userActivity,
} from "../../../common/constants";
import { Mixpanel } from "../../../config/Mixpanel";
import ReactPixel from "react-facebook-pixel";
import { addUserActivity } from "../../../redux/actions/profileDetails";

const PricingMonthlyCard = ({
  id,
  cardData,
  details,
  isCardEnabled,
  setIsCardEnabled,
  userPlan,
  isModalEnabled,
  setIsModalEnabled,
  cardDatas,
  razorpayHandler,
  scrollToProMonthly,
  section,
}) => {
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const discountData = useSelector((store) => store?.userDiscount?.discount);
  const discountPeriod = useSelector(
    (store) => store?.userDiscount?.expires_at,
  );
  const authentication = useSelector((store) => store?.authentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [pricingSpinner, setPricingSpinner] = useState(false);
  const scrollRef = useRef();

  const email = useSelector((store) => store?.profileDetails?.email);
  const isEpsCalculated = useSelector(
    (store) => store?.userActivity?.eps_score?.is_eps_calculated,
  );
  const eps_score = useSelector(
    (store) => store?.userActivity?.eps_score?.calculated_eps_score,
  );
  let isFirstBlank = false;
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (parseInt(section) === id || scrollToProMonthly === id) {
      console.log("insidr");
      if (scrollRef?.current) {
        scrollRef?.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [searchParams.get("section"), scrollToProMonthly]);

  function toggleBackgroundColor(id, isCardEnabled) {
    if (isCardEnabled) {
      if (id === 3)
        return "  w-full md:w-[300px] mb-10  md:ml-1 md:mr-1 lg:ml-4 lg:mr-4 bg-pricing_blue flex flex-col border-4 border-[#C7A700] rounded-2xl  items-center cursor-pointer";
      else
        return " w-full md:w-[300px] mb-10  md:ml-1 md:mr-1 lg:ml-4 lg:mr-4 bg-pricing_blue flex flex-col border-2 border-gray-300 md:border-gray-200 rounded-2xl  items-center cursor-pointer";
    } else {
      if (id === 3) {
        return " w-full md:w-[300px] mb-10  md:ml-1 md:mr-1 lg:ml-4 lg:mr-4 bg-white flex flex-col border-4 border-[#C7A700] rounded-2xl  items-center cursor-pointer";
      } else {
        return " w-full md:w-[300px] mb-10  md:ml-1 md:mr-1 lg:ml-4 lg:mr-4 bg-white flex flex-col border-2 border-gray-300 md:border-gray-200 rounded-2xl  items-center cursor-pointer";
      }
    }
  }
  function toggleFeatureDetailsColor(isCardEnabled) {
    if (isCardEnabled) return " text-xs mb-2 text-white whitespace-nowrap";
    else return " text-xs mb-2 text-stone-500 whitespace-nowrap";
  }
  function togglePriceColor(isCardEnabled) {
    if (isCardEnabled) return "text-4xl text-white font-bold mb-2";
    else return "text-4xl font-bold mb-2";
  }

  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const validity =
    (userPlan?.current_subscription_expires_at -
      userPlan?.current_subscription_started_at) /
    (1000 * 60 * 60 * 24 * 30);
  const planValidity = cardData?.validity;
  const getPeriod = () => {
    if (planValidity === 30) return 1;
    else if (planValidity === 90) return 3;
    else return 6;
  };

  function createLeadsForCards(metadata) {
    dispatch(
      addUserActivity(user_id, userActivity.PAYMENT_ATTEMPT, "", false, null),
    );
    switch (metadata?.product_name) {
      case "LearnTube Pro":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTPRO.type),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPRO, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Pro+":
        {
          dispatch(
            createLeadScore(
              user_id,
              leadScoringActivity.CLICKED_LTPROPLUS.type,
            ),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPROPLUS, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTubeX":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTX.type),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTX, {
            distinct_id: email,
          });
        }
        break;
      default:
        break;
    }
  }

  function createLeads(metadata) {
    switch (metadata?.product_name) {
      case "LearnTube Pro":
        {
          dispatch(
            createLeadScore(
              user_id,
              leadScoringActivity.CLICKED_LTPRO_CARD.type,
            ),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPRO_CARD, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Pro+":
        {
          dispatch(
            createLeadScore(
              user_id,
              leadScoringActivity.CLICKED_LTPROPLUS_CARD.type,
            ),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPROPLUS_CARD, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTubeX":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTX_CARD.type),
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTX_CARD, {
            distinct_id: email,
          });
        }
        break;
      default:
        break;
    }
  }

  return (
    <div
      className={toggleBackgroundColor(id, isCardEnabled)}
      onClick={(event) => {
        setIsCardEnabled(id);
        createLeads(cardData);
      }}
      ref={scrollRef}
    >
      {id === 2 ? (
        <>
          <div className="-mt-6 h-10 w-2/3 rounded-2xl bg-cyan-400 pt-2 text-center font-bold text-white">
            Most Purchased
          </div>

          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={cardData?.pp_product_image_url}
            transformation={[
              {
                height: "100",
                width: "100",
              },
            ]}
            className="mt-2 mb-2 h-20"
          />
        </>
      ) : (
        <></>
      )}
      {id === 3 && (
        <>
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={
              "https://img.learntube.ai/public-assets/PRICING/img4.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658852702613"
            }
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
            className="-mt-4"
          />
          <p className="-mt-8 text-sm font-bold text-white md:-mt-7 ">
            BEST VALUE
          </p>
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={cardData?.pp_product_image_url}
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
            className="mt-3 mb-3 h-20"
          />
        </>
      )}

      {id === 1 && (
        <img
          urlEndpoint="https://img.learntube.ai/public-assets/"
          src={cardData?.pp_product_image_url}
          transformation={[
            {
              height: "100",
              width: "100",
            },
          ]}
          className="mt-4 mb-4 h-20"
        />
      )}
      <h1
        className={
          isCardEnabled
            ? "mb-0 text-lg font-bold text-white"
            : "mb-0 text-lg  font-bold"
        }
      >
        {cardData?.product_name}
      </h1>
      <h4
        className={isCardEnabled ? "mb-2 text-sm text-white" : "mb-2 text-sm"}
      >
        {Math.floor(cardData?.validity / 30)}-Months
      </h4>
      <div
        className={`${togglePriceColor(
          isCardEnabled,
        )} flex flex-col items-center justify-center`}
      >
        {discountData === undefined ||
        discountPeriod - new Date().getTime() <= 0 ||
        authentication === null ? (
          <>
            <div className="flex flex-row">
              <h1>₹{Math.ceil(cardData?.cost / getPeriod())}</h1>
              <h4 className="self-end text-lg font-medium">/Month</h4>
            </div>
            <div className="flex flex-row">
              <h1 className="text-lg font-medium text-red-500 line-through">
                ₹{Math.ceil(cardData?.pp_original_cost / getPeriod())}
              </h1>
              <h4 className="self-end text-lg font-medium text-red-500 line-through">
                /Month
              </h4>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-row">
              <h1>
                ₹
                {Math.ceil(
                  (cardData?.cost - (cardData?.cost * discountData) / 200) /
                    getPeriod(),
                )}
              </h1>
              <h4 className="self-end text-lg font-medium">/Month</h4>
            </div>
            <div className="flex flex-row">
              <h1 className="text-lg font-medium text-red-500 line-through">
                ₹{Math.ceil(cardData?.cost / getPeriod())}
              </h1>
              <h4 className="self-end text-lg font-medium text-red-500 line-through">
                /Month
              </h4>
            </div>
          </>
        )}
      </div>

      <button
        value={cardData?.id}
        className="item-center mb-5 flex w-10/12 justify-center rounded-3xl bg-gradient-to-r from-amber-400 to-amber-600 py-2 text-center text-sm font-bold text-white shadow-xl md:mb-3"
        onClick={(e) => {
          if (user_id) {
            setPricingSpinner(true);
            Mixpanel.track(Constants.Mixpanel.PAYMENT_ATTEMPT, {
              distinct_id: email,
            });
            ReactPixel.trackSingle("333999584825866", "Attempt_to_pay");
            dispatch(
              getLeads({
                user_id,
                user_plan: userPlan?.role_type,
                product_id: cardData?.id,
                product_name: cardData?.product_name,
                product_type: "subscription",
                is_visit: false,
              }),
            );
            createLeadsForCards(cardData);
            razorpayHandler(cardData?.id, () => {
              setPricingSpinner(false);
            });
          } else {
            navigate("/login", { state: { from: location } });
          }
        }}
      >
        {pricingSpinner === true ? (
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-white border-t-transparent"></div>
        ) : (
          <div className="flex flex-col">
            {(id === 1 && userPlan?.user_role === 2 && validity < 2) ||
            (id === 2 &&
              userPlan?.user_role === 2 &&
              validity >= 2 &&
              validity <= 4) ||
            (id === 3 && userPlan?.user_role === 2 && validity > 4) ? (
              <h1>Renew Subscription</h1>
            ) : (
              <h1>{cardData?.pp_button_text}</h1>
            )}
            {discountData === undefined ||
            discountPeriod - new Date().getTime() <= 0 ||
            authentication === null ? (
              <h1 className="text-xs font-normal">
                ₹{cardData?.cost} For {Math.floor(cardData?.validity / 30)}
                -Months
              </h1>
            ) : (
              <h1 className="text-xs font-normal">
                {" "}
                ₹
                {Math.ceil(
                  cardData?.cost - (cardData?.cost * discountData) / 200,
                )}{" "}
                For {Math.floor(cardData?.validity / 30)}-Months
              </h1>
            )}
          </div>
        )}
      </button>
      <hr
        className={
          isCardEnabled
            ? "mt-3 mb-5 w-2/5 border-white"
            : " mt-3   mb-5 w-2/5 border-neutral-50"
        }
      ></hr>
      <div className={"flex flex-col"}>
        {details.map((detail) => (
          <div className="flex ">
            {detail === "`" ? (
              isEpsCalculated && isFirstBlank === false ? (
                <h4
                  className={`flex ${toggleFeatureDetailsColor(isCardEnabled)}`}
                >
                  {(isFirstBlank = true)}
                  <span
                    className={`border-2 p-1  text-xs font-semibold no-underline ${
                      isCardEnabled
                        ? "border-white text-white"
                        : "border-[#086788] text-[#086788]"
                    } mr-1 flex h-4 w-4 items-center justify-center rounded-full`}
                  >
                    i
                  </span>
                  Boost Your Job score to 67%
                </h4>
              ) : (
                <h4 className={`${toggleFeatureDetailsColor(isCardEnabled)}`}>
                  &nbsp;
                </h4>
              )
            ) : (
              <>
                {" "}
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"
                  }
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                  className="mr-2 ml-0 h-4 lg:mr-1 lg:ml-0 "
                />
                <h4 className={toggleFeatureDetailsColor(isCardEnabled)}>
                  {detail}
                </h4>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingMonthlyCard;
